/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  RelatedCase,
  RelatedCaseCreate,
  RelatedCaseUpdate,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    RelatedCaseFromJSON,
    RelatedCaseToJSON,
    RelatedCaseCreateFromJSON,
    RelatedCaseCreateToJSON,
    RelatedCaseUpdateFromJSON,
    RelatedCaseUpdateToJSON,
} from '../models/index';

export interface CreateRelatedCaseApiV1RelatedCasesPostRequest {
    relatedCaseCreate: RelatedCaseCreate;
}

export interface CreateRelatedCaseApiV1RelatedCasesPost0Request {
    relatedCaseCreate: RelatedCaseCreate;
}

export interface DeleteRelatedCaseApiV1RelatedCasesIdDeleteRequest {
    id: number;
}

export interface ReadRelatedCaseApiV1RelatedCasesIdGetRequest {
    id: number;
}

export interface ReadRelatedCasesApiV1RelatedCasesGetRequest {
    skip?: number;
    limit?: number;
}

export interface ReadRelatedCasesApiV1RelatedCasesGet0Request {
    skip?: number;
    limit?: number;
}

export interface UpdateRelatedCaseApiV1RelatedCasesIdPutRequest {
    id: number;
    relatedCaseUpdate: RelatedCaseUpdate;
}

/**
 * 
 */
export class RelatedCasesApi extends runtime.BaseAPI {

    /**
     * Create new related case.
     * Create Related Case
     */
    async createRelatedCaseApiV1RelatedCasesPostRaw(requestParameters: CreateRelatedCaseApiV1RelatedCasesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelatedCase>> {
        if (requestParameters['relatedCaseCreate'] == null) {
            throw new runtime.RequiredError(
                'relatedCaseCreate',
                'Required parameter "relatedCaseCreate" was null or undefined when calling createRelatedCaseApiV1RelatedCasesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/related-cases/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RelatedCaseCreateToJSON(requestParameters['relatedCaseCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RelatedCaseFromJSON(jsonValue));
    }

    /**
     * Create new related case.
     * Create Related Case
     */
    async createRelatedCaseApiV1RelatedCasesPost(requestParameters: CreateRelatedCaseApiV1RelatedCasesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelatedCase> {
        const response = await this.createRelatedCaseApiV1RelatedCasesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new related case.
     * Create Related Case
     */
    async createRelatedCaseApiV1RelatedCasesPost_1Raw(requestParameters: CreateRelatedCaseApiV1RelatedCasesPost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelatedCase>> {
        if (requestParameters['relatedCaseCreate'] == null) {
            throw new runtime.RequiredError(
                'relatedCaseCreate',
                'Required parameter "relatedCaseCreate" was null or undefined when calling createRelatedCaseApiV1RelatedCasesPost_1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/related-cases`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RelatedCaseCreateToJSON(requestParameters['relatedCaseCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RelatedCaseFromJSON(jsonValue));
    }

    /**
     * Create new related case.
     * Create Related Case
     */
    async createRelatedCaseApiV1RelatedCasesPost_1(requestParameters: CreateRelatedCaseApiV1RelatedCasesPost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelatedCase> {
        const response = await this.createRelatedCaseApiV1RelatedCasesPost_1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a related case.
     * Delete Related Case
     */
    async deleteRelatedCaseApiV1RelatedCasesIdDeleteRaw(requestParameters: DeleteRelatedCaseApiV1RelatedCasesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelatedCase>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteRelatedCaseApiV1RelatedCasesIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/related-cases/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RelatedCaseFromJSON(jsonValue));
    }

    /**
     * Delete a related case.
     * Delete Related Case
     */
    async deleteRelatedCaseApiV1RelatedCasesIdDelete(requestParameters: DeleteRelatedCaseApiV1RelatedCasesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelatedCase> {
        const response = await this.deleteRelatedCaseApiV1RelatedCasesIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get related case by ID.
     * Read Related Case
     */
    async readRelatedCaseApiV1RelatedCasesIdGetRaw(requestParameters: ReadRelatedCaseApiV1RelatedCasesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelatedCase>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling readRelatedCaseApiV1RelatedCasesIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/related-cases/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RelatedCaseFromJSON(jsonValue));
    }

    /**
     * Get related case by ID.
     * Read Related Case
     */
    async readRelatedCaseApiV1RelatedCasesIdGet(requestParameters: ReadRelatedCaseApiV1RelatedCasesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelatedCase> {
        const response = await this.readRelatedCaseApiV1RelatedCasesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve related cases.
     * Read Related Cases
     */
    async readRelatedCasesApiV1RelatedCasesGetRaw(requestParameters: ReadRelatedCasesApiV1RelatedCasesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RelatedCase>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/related-cases/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RelatedCaseFromJSON));
    }

    /**
     * Retrieve related cases.
     * Read Related Cases
     */
    async readRelatedCasesApiV1RelatedCasesGet(requestParameters: ReadRelatedCasesApiV1RelatedCasesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RelatedCase>> {
        const response = await this.readRelatedCasesApiV1RelatedCasesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve related cases.
     * Read Related Cases
     */
    async readRelatedCasesApiV1RelatedCasesGet_2Raw(requestParameters: ReadRelatedCasesApiV1RelatedCasesGet0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RelatedCase>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/related-cases`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RelatedCaseFromJSON));
    }

    /**
     * Retrieve related cases.
     * Read Related Cases
     */
    async readRelatedCasesApiV1RelatedCasesGet_2(requestParameters: ReadRelatedCasesApiV1RelatedCasesGet0Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RelatedCase>> {
        const response = await this.readRelatedCasesApiV1RelatedCasesGet_2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a related case.
     * Update Related Case
     */
    async updateRelatedCaseApiV1RelatedCasesIdPutRaw(requestParameters: UpdateRelatedCaseApiV1RelatedCasesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelatedCase>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateRelatedCaseApiV1RelatedCasesIdPut().'
            );
        }

        if (requestParameters['relatedCaseUpdate'] == null) {
            throw new runtime.RequiredError(
                'relatedCaseUpdate',
                'Required parameter "relatedCaseUpdate" was null or undefined when calling updateRelatedCaseApiV1RelatedCasesIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/related-cases/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RelatedCaseUpdateToJSON(requestParameters['relatedCaseUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RelatedCaseFromJSON(jsonValue));
    }

    /**
     * Update a related case.
     * Update Related Case
     */
    async updateRelatedCaseApiV1RelatedCasesIdPut(requestParameters: UpdateRelatedCaseApiV1RelatedCasesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelatedCase> {
        const response = await this.updateRelatedCaseApiV1RelatedCasesIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
